'use client'

import { Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

const PrivacyCertificationSection = () => {
  const translate = useTranslate('privacy_center.certification_section')
  const assets = useAsset('/assets/privacy-center/')

  return (
    <section className="privacy-center__certification-section">
      <div className="privacy-center__certification-content-container">
        <div className="privacy-center__certification-title-container">
          <img src={assets('epCertification.png')} loading="lazy" alt="" />
          <h2 className="privacy-center__certification-title">{translate('title')}</h2>
        </div>
        <div className="privacy-center__certification-description">
          <Text as="p" text={translate('description')} html alignment={Text.Alignment.Center} />
        </div>

        <div className="privacy-center__certification-link">
          <Text
            as="div"
            text={translate('link')}
            html
            aria={{ 'aria-label': translate('link_a11y') }}
          />
        </div>
      </div>
    </section>
  )
}

export default PrivacyCertificationSection
